import type { RouteRecordRaw } from 'vue-router'

export default (): RouteRecordRaw[] => {
  return [
    {
      name: 'partnerships-bouygues-offers-webview',
      path: 'partnerships/webview',
      meta: {
        layout: false,
        tracking: { contentGroup: 'Partnerships' },
      },
      children: [
        {
          name: 'partnerships-webview-bouygues-offers',
          path: 'bouygues-offers',
          component: () =>
            import('~/scopes/partnerships/pages/BouyguesOffersWebview/BouyguesOffersWebview.vue'),
          meta: {
            owners: ['bot-squad-partnerships-front'],
          },
        },
      ],
    },
  ]
}
